<template>
  <j-modal :width="modalWidth" :visible="visible" :title="title" switchFullscreen @ok="handleSubmit" @cancel="close"
    style="top:50px" cancelText="关闭">
    <a-row :gutter="10" style="background-color: #ececec; padding: 10px; margin: -10px">
      <a-col :md="6" :sm="24">
        <a-card :bordered="false">
          <!--组织机构-->
          <a-directory-tree selectable :selectedKeys="selectedDepIds" :checkStrictly="true"
            :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }" :treeData="departTree" :expandAction="false"
            :expandedKeys.sync="expandedKeys" @select="onDepSelect" />
        </a-card>
      </a-col>
      <a-col :md="18" :sm="24">
        <a-card :bordered="false">
          用户账号:
          <a-input-search :style="{ width: '150px', marginBottom: '15px' }" placeholder="请输入账号" v-model="queryParam.username"
            @search="onSearch"></a-input-search>
          <a-button @click="searchReset(1)" style="margin-left: 20px" icon="redo">重置</a-button>
          <!--用户列表-->
          <a-table ref="table" :scroll="scrollTrigger" size="middle" :rowKey="isGg?'id':'username'" :columns="columns"
            :dataSource="dataSource" :pagination="ipagination" :customRow="customRow"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, onSelect: onSelect, onSelectAll: onSelectAll, type: getType }"
            :loading="loading" @change="handleTableChange">
          </a-table>
        </a-card>
      </a-col>
    </a-row>
  </j-modal>
</template>

<script>
import { filterObj } from '@/utils/util'
import { queryDepartTreeList, getUserList, queryUserByDepId } from '@/api/api'
import { findIndex } from 'min-dash'

export default {
  name: 'JSelectUserByDepModal',
  components: {},
  props: ['modalWidth', 'multi', 'userIds', 'isGg'],
  data() {
    return {
      queryParam: {
        username: "",
      },
      columns: [
        {
          title: '用户账号',
          align: 'center',
          dataIndex: 'username'
        },
        {
          title: '用户姓名',
          align: 'center',
          dataIndex: 'realname'
        },
        {
          title: '性别',
          align: 'center',
          dataIndex: 'sex',
          customRender: function (text) {
            if (text === 1) {
              return '男'
            } else if (text === 2) {
              return '女'
            } else {
              return text
            }
          }
        },
        {
          title: '手机',
          align: 'center',
          dataIndex: 'phone'
        },
        {
          title: '部门',
          align: 'center',
          dataIndex: 'orgCode'
        }
      ],
      scrollTrigger: {},
      dataSource: [],
      selectedRowKeys: [],
      selectionRows: [],
      selectUserRows: [],
      selectUserIds: [],
      title: '根据部门选择用户',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      selectedDepIds: [],
      departTree: [],
      visible: false,
      form: this.$form.createForm(this),
      loading: false,
      expandedKeys: [],
    }
  },
  computed: {
    // 计算属性的 getter
    getType: function () {
      return this.multi == true ? 'checkbox' : 'radio';
    }
  },
  watch: {
    userIds: {
      immediate: true,
      handler() {
        this.initUserNames()
      }
    },
  },
  created() {
    // 该方法触发屏幕自适应
    this.resetScreenSize();
    this.loadData()
  },
  methods: {
    customRow(record, index) {
      return {
        on: {
          click: (e) => {
            if (this.multi) {
              let index = this.selectedRowKeys.findIndex(key => key == e.currentTarget.dataset.rowKey);
              if (index > -1) {
                this.selectedRowKeys.splice(index, 1);
              } else {
                this.selectedRowKeys.push(e.currentTarget.dataset.rowKey);
              }
            } else {
              this.selectedRowKeys = [e.currentTarget.dataset.rowKey];
            }
          }
        }
      }
    },
    initUserNames() {
      if (this.userIds) {
        // 这里最后加一个 , 的原因是因为无论如何都要使用 in 查询，防止后台进行了模糊匹配，导致查询结果不准确
        let values = this.userIds.split(',') + ','
        let params = {
          pageNo: 1,
          pageSize: values.length
        }
        if (this.isGg) {
          params.id = values
        } else {
          params.username = values
        }
        getUserList(params).then((res) => {
          if (res.success) {
            let selectedRowKeys = []
            let realNames = []
            res.result.records.forEach(user => {
              realNames.push(user['realname'])
              if(this.isGg){
                selectedRowKeys.push(user['id']);
              }else{
                selectedRowKeys.push(user['username']);
              }
            })
            this.selectedRowKeys = selectedRowKeys
            this.$emit('initComp', realNames.join(','))
          }
        })
      } else {
        // JSelectUserByDep组件bug issues/I16634
        this.$emit('initComp', '')
      }
    },
    async loadData(arg) {
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      if (this.selectedDepIds && this.selectedDepIds.length > 0) {
        await this.initQueryUserByDepId(this.selectedDepIds)
      } else {
        this.loading = true
        let params = this.getQueryParams()//查询条件
        await getUserList(params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records
            this.ipagination.total = res.result.total
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    // 触发屏幕自适应
    resetScreenSize() {
      let screenWidth = document.body.clientWidth;
      if (screenWidth < 500) {
        this.scrollTrigger = { x: 800 };
      } else {
        this.scrollTrigger = {};
      }
    },
    showModal() {
      this.visible = true;
      this.queryDepartTree();
      this.initUserNames()
      this.loadData();
      this.form.resetFields();
    },
    getQueryParams() {
      let param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      let str = 'id,';
      for (let a = 0; a < this.columns.length; a++) {
        str += ',' + this.columns[a].dataIndex;
      }
      return str;
    },
    searchReset(num) {
      let that = this;
      if (num !== 0) {
        that.queryParam = {};
        that.loadData(1);
      }
      that.selectedRowKeys = [];
      that.selectUserIds = [];
      that.selectedDepIds = [];
    },
    close() {
      this.searchReset(0);
      this.visible = false;
    },
    handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' === sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.loadData();
    },
    handleSubmit () {
      let that = this;
      //this.getSelectUserRows();
      that.$emit('ok', that.selectionRows, that.selectedRowKeys.join(','));
      that.searchReset(0)
      that.close();
    },
    //获取选择用户信息
    getSelectUserRows(rowId) {
      let dataSource = this.dataSource;
      let userIds = "";
      this.selectUserRows = [];
      for (let i = 0, len = dataSource.length; i < len; i++) {
        if (this.selectedRowKeys.includes(dataSource[i].id)) {
          this.selectUserRows.push(dataSource[i]);
          if (this.isGg) {
            userIds = userIds + "," + dataSource[i].id
          } else {
            userIds = userIds + "," + dataSource[i].username // 旧
          }
        }
      }
      this.selectUserIds = userIds.substring(1);
    },
    // 点击树节点,筛选出对应的用户
    onDepSelect(selectedDepIds) {
      if (selectedDepIds[0] != null) {
        this.initQueryUserByDepId(selectedDepIds); // 调用方法根据选选择的id查询用户信息
        if (this.selectedDepIds[0] !== selectedDepIds[0]) {
          this.selectedDepIds = [selectedDepIds[0]];
        }
      }
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      // this.selectionRows = selectionRows;
    },
    // TODO单选触发
    onSelect(record, selected, selectedRows) {
      if (selected == true) {
        this.selectionRows.push(record);
      } else {
        this.selectionRows.forEach(function (item, index, arr) {
          if (item.id == record.id) {
            arr.splice(index, 1);
          }
        })
      }

      console.log("onSelect:this.selectionRows", this.selectionRows)
      //--update-end----author:kangxiaolin---date:20190921------for:系统发送通知 用户多选失败 #513----
    },

    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        this.selectionRows = this.selectionRows.concat(changeRows);

      } else {
        for (let i = 0; i < changeRows.length; i++) {
          let delIndex = this.selectionRows.findIndex(val => {
            return val.id === changeRows[i].id
          })
          this.selectionRows.splice(delIndex, 1);
        }
      }

    },
    onSearch() {
      this.loadData(1);
    },
    // 根据选择的id来查询用户信息
    initQueryUserByDepId(selectedDepIds) {
      this.loading = true
      return queryUserByDepId({ id: selectedDepIds.toString() }).then((res) => {
        if (res.success) {
          this.dataSource = res.result;
          this.ipagination.total = res.result.length;
        }
      }).finally(() => {
        this.loading = false
      })
    },
    queryDepartTree() {
      queryDepartTreeList().then((res) => {
        if (res.success) {
          this.departTree = res.result;
          // 默认展开父节点
          this.expandedKeys = this.departTree.map(item => item.id)
        }
      })
    },
    modalFormOk() {
      this.loadData();
    }
  }
}
</script>

<style scoped>
.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color .3s;
}
</style>